<template>
    <div class="container">
      <div class="content">
        <div class="logo"></div>
        <div class="sLine"></div>
        <div class="text1">数字三一   智造未来！ 欢迎您使用</div>
        <div class="text2">三一路面机械数字化施工云平台</div>
        <div class="loginInfo">
          <el-form ref="refForm" :model="refForm" id="form1" action="">
            <div class="form">
              <div class="userClass sameSet">
                <div class="left">用户名</div>
                <el-input class="form-field animation a3 username" name="userName" v-model="refForm.identity" placeholder="请输入账号" @input="userNameChange"></el-input>
                <div class="userNameDel" @click="removeName" v-if="userNameDelShow"></div>
                <div style="clear: both;"></div>
              </div>
              <div class="userClass sameSet">
                <div class="left">密码</div>
                <el-input name="password" :type="passwordType" v-model="refForm.password" class="form-field animation a4 password" placeholder="请输入密码" @input="passwordChange" @keydown.native.stop="handleKeyDown"></el-input>
                <div class="eye" @click="changeEye" v-if="eyeShow"></div>
                <div style="clear: both;"></div>
              </div>
              <div class="userClass sameSet" v-if="loginError">
                <div class="left">验证码</div>
                <el-input name="captcha" v-model="refForm.captcha" class="form-field animation a4 captcha" placeholder="请输入验证码" @keydown.native.stop="handleKeyDown"></el-input>
                <div class="sLinecap"></div>
                <div class="captcha animation a4" style="width:100px;height: 25px;position: absolute;top:15px;right: 4px;">
                    <img class="captchaImg" @click="changeCaptcha" :src="captchaImgUrl" alt="" style="height: 100%;width:100%;cursor: pointer">
                    <!-- <div class="captchaImg" src="" alt="" style="height: 100%;width:100%;cursor: pointer"></div> -->
                </div>
                <div style="clear: both;"></div>
              </div>

              <div class="animation a6 loginIn">
                <el-button class="animation a6 loginIn_btn" formTy type="primary" @click="handleLogin">登 录</el-button>
              </div>
              <div class="lx">有问题,请联系：Ljszh_service@sany.com.cn</div>
              <!-- <div class="animation a6 forget">忘记密码? 请联系管理员></div> -->
            </div>
          </el-form>
        </div>
        <!-- <div class="blockShow"></div> -->
        <div class="text3">©2019三一智能 版权所有 湘ICP备10005672号-3</div>
      </div>
    </div>

</template>

<script>
  import {toLogin,getUserSetting} from "../utils/api"
  import {encryption} from "../utils/commons"
  import Cookies from 'js-cookie' 
  import { Message} from 'element-ui';
  export default {
    name      : 'app',
    data() {
      return {
        refForm:{
            identity: "",
            password: "",
            captcha: ''
        },
        captchaImgUrl: '',
        userNameDelShow: false,
        eyeShow: false,
        passwordType: 'password',
        expandedKeys: [],
        loginError:false,
        url: localStorage.getItem("baseURL"),
      }
    },
    computed:{

    },
    created(){

    },
    mounted(){
      // this.captchaImgUrl = localStorage.getItem("baseURL")+'/auth/api/v1/captcha.jpg'
    },
    methods: {
        //回车键登录
        handleKeyDown:function(e){
          let eCode = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;
          if (eCode === 13) {
            this.handleLogin();
          }
        },
        changeCaptcha: function(){
          this.captchaImgUrl = ''
          let that = this
          setTimeout(function(){
            that.captchaImgUrl = localStorage.getItem("baseURL")+'/auth/api/v1/captcha.jpg'

            // let request = new XMLHttpRequest();
            // request.responseType = 'blob';
            // request.open('get', localStorage.getItem("baseURL")+'/auth/api/v1/captcha.jpg', true);
            // request.onreadystatechange = (e) => {
            //   console.log(e)
            //   if (request.readyState == XMLHttpRequest.DONE && request.status == 200) {
            //     let setCookie = request.getAllResponseHeaders();
            //     // var headr = request.getAllResponseHeaders();
            //     console.info(setCookie);
            //     // console.log("X-Timestamp== " + xTimestamp);
            //     console.info(request.response);
            //     that.captchaImgUrl = URL.createObjectURL(request.response);
            //     // that.captchaImgUrl.onload = () => {
            //     //   URL.revokeObjectURL(that.captchaImgUrl.src);
            //     // }
            //   }
            // };
            // request.send(null);
          },100)
          
        },
        removeName: function(){
          this.refForm.identity = ''
          this.userNameDelShow = false
        },
        changeEye: function(){
          if(this.passwordType == 'password'){
            this.passwordType = 'text'
          }else{
            this.passwordType = 'password'
          }
        },
        handleLogin:function(){
          if(this.loginError==true && this.refForm.captcha==''){
            Message.error("请输入验证码");
            return
          }
          if(this.refForm.identity==''){
            Message.error("请输入用户名");
            return
          }
          if(this.refForm.password==''){
            Message.error("请输入密码");
            return
          }
          let obj={...this.refForm}
          obj.password=encryption(obj.password)
            toLogin(obj).then(res => {
                if(res.data.code == 400){
                  this.loginError=true
                  this.changeCaptcha();
                  this.refForm.captcha=''
                  return
                }
                Cookies.set('token', res.data.content.user.token);
                window.localStorage.setItem("userCode", res.data.content.user.userCode);
                window.localStorage.setItem("roleCode", res.data.content.user.roleCode);
                window.localStorage.setItem("corpCode", res.data.content.user.corpCode);
                //登录时清除质量管理页面的图例，在进入质量管理页面的时候重新获取
                localStorage.removeItem('setIcv_exam')
                localStorage.removeItem('setRn_exam')
                // this.$router.push({name:'HomePage'});
                let userName = res.data.content.user.name
                this.$store.commit('setUserName', userName)
                if(res.data.content.menuList){
                  // 获取权限
                  let getList = res.data.content.menuList
                  let getRoleList = []
                  for(let i=0;i<getList.length;i++){
                    if(getList[i].id == 'menu-c51a5dcdf6bb485393ee5df732e103bf'){
                      getRoleList.push(getList[i])
                    }
                  }
                  let dataList = this.setName(getRoleList)
                  window.localStorage.setItem("userRoleList", dataList);
                }else{
                  // 获取权限
                  let getList = res.data.content.menus
                  let dataList = []
                  for(let i=0;i<getList.length;i++){
                    dataList.push(getList[i].menuCode)
                  }
                  window.localStorage.setItem("userRoleList", dataList);
                }
                getUserSetting().then(r=>{
                  
                  if(r.data.code == 200) {
                    Message.success("登录成功")
                  }
                  let homeType = ''
                  if(r.data.content.info.homeType){
                    homeType = r.data.content.info.homeType
                  }else{
                    homeType = 0
                  }
                  
                  localStorage.setItem("homeType",homeType)
                  if(res.data.content.user.needUpdatePassword){
                    this.$router.push({name:'Person',query:{type:1}});
                  }else{
                    if(homeType == 0){
                      this.$router.push({name:'HomePage'});
                    }else if(homeType == 1){
                      this.$router.push({name:'DevicePage'});
                    }else{
                      this.$router.push({name:'HomePageZ'});
                    }
                  }
                  
                })
                window.localStorage.setItem("userName", userName);
                window.localStorage.setItem("roleCode", res.data.content.user.roleCode);
                window.localStorage.setItem("roleName", res.data.content.user.roleName);
                window.localStorage.setItem('pageWorkId',0)
            })
        },
        setName(datas){ //遍历树  获取id数组
          for(var i in datas){
            this.expandedKeys.push(datas[i].id)
            if(datas[i].children){
              this.setName(datas[i].children);
            }
          }
          return this.expandedKeys
        },
        userNameChange: function(e){
          if(e != ''){
            this.userNameDelShow = true
          }else{
            this.userNameDelShow = false
          }
        },
        passwordChange: function(e){
          if(e != ''){
            this.eyeShow = true
          }else{
            this.eyeShow = false
          }
        },
        
    },
    components:{
            
    }
  }
</script>
<style lang='scss'>
.loginInfo{
    .el-input{
      height: 53px !important;
      width: 408px !important;
      .el-input__inner{
        height: 53px !important;
        width: 408px !important;
        border: 0
      }
    }
    .loginIn_btn{
      width: 420px !important;
      height: 60px !important;
      border-radius: 10px !important
    }
}
</style>
<style lang="scss" scoped="">
.captchaImg{
  height: 25px;
  width: 100px;
  background-size: 100% 100%;
}
.container{
  height: 100%;
  width: 100%;
  // background-color: aquamarine;
  background-image: url(../images/loginBG.png);
  background-size: 100% 100%;
  
  .content{
    height: 100%;
    width: 680px;
    // background-color: azure;
    margin: 0 auto;
    position: relative;
    .logo{
      height: 64px;
      width: 251px;
      background-image: url(../images/loginLogo.png);
      background-size: 100% 100%;
      position: absolute;
      top: 215px;
      left: 5px;
    }
    .sLine{
      width: 1px;
      height: 55px;
      background-color: #ffffff;
      opacity: 0.7;
      position: absolute;
      top: 221px;
      left: 265px;
    }
    .text1{
      height: 17px;
      line-height: 17px;
      font-size: 16px;
      color: #cccccc;
      position: absolute;
      top: 215px;
      left: 279px;
      letter-spacing: 1px;
    }
    .text2{
      height: 34px;
      line-height: 34px;
      font-size: 26px;
      color: #cccccc;
      position: absolute;
      top: 244px;
      left: 279px;
      letter-spacing: 2px;
      font-weight: 600;
    }
    .text3{
      height: 16px;
      width: 100%;
      text-align: center;
      line-height: 16px;
      font-size: 15px;
      color: #999999;
      position: absolute;
      bottom: 44px;
      letter-spacing: 1px;
    }
    // .blockShow{
    //   height: 50px;
    //   width: 640px;
    //   background-color: #ffffff;
    //   border-radius: 8px;
    //   opacity: 0.45;
    //   position: absolute;
    //   top: 737px;
    //   left: 20px;
    // }
    .loginInfo{
      position: absolute;
      min-height: 360px;
      width: 680px;
      top: 312px;
      left: 0;
      background-color: #ffffff;
      border-radius: 8px;
      z-index: 10;
      #form1{
        height: 100%;
        width: 100%;
          .form{
            height: 100%;
            width: 100%;
            padding-top: 40px;
            .lx{
              width: 100%;
              height: 50px;
              line-height: 50px;
              text-align: center;
              // background-color: aqua;
              font-size: 14px;
              color: #999999;
            }
            .userClass{
              margin-top: 26px !important; 
              position: relative;
              .userNameDel{
                width: 20px;
                height: 20px;
                background-image: url(../images/loginDel.png);
                background-size: 100% 100%;
                position: absolute;
                top: 17px;
                right: 16px;
                cursor: pointer;
              }
              .eye{
                width: 20px;
                height: 15px;
                background-image: url(../images/all/eye.png);
                background-size: 100% 100%;
                position: absolute;
                top: 19px;
                right: 16px;
                cursor: pointer;
              }
              .sLinecap{
                height: 30px;
                width: 1px;
                background-color: #e1e1e1;
                position: absolute;
                top: 12px;
                right: 114px;
              }
            }
            .sameSet{
              height: 55px;
              width: 520px;
              margin: 0 auto;
              border-radius: 4px;
              background-color: #ffffff; 
              border: solid 1px #e1e1e1;
            }
            .left{
              height: 100%;
              width: 89px;
              line-height: 55px;
              text-align: center;
              background-color: #f3f5f7;
              float: left;
              border-radius: 4px 0 0 4px;
              letter-spacing: 1px;
              color: #282828;
              font-size: 15px;
            }
            .form-field{
              height: 53px;
              width: 428px;
              letter-spacing: 1px;
              color: #555555;
              font-size: 15px;
              padding-left: 16px;
              float: left;
              border: none;
              border-radius: 0 4px 4px 0;
            }
          }
        .loginIn{
          width: 420px;
          height: 60px;
          margin: 0 auto;
          margin-top: 43px;
          // background-color: #e00303;
          border-radius: 30px;
          line-height: 60px;
          text-align: center;
          cursor: pointer;
          letter-spacing: 1px;
          color: #ffffff;
          font-size: 18px;
          
        }
        .forget{
          width: 100%;
          height: 16px;
          text-align: center;
          margin-top: 29px;
          line-height: 16px;
          text-align: center;
          letter-spacing: 1px;
          color: #555555;
          font-size: 15px;
        }
      }
      
    }
  }
}
</style>